export const matchQueryToPhoneNumber = (query: string): RegExp =>
  new RegExp(`((\\+|0|00)\\d{0,2})?(\\d+)?${query}(\\d+)?`);

export function formatStretchName(name: string) {
  return (
    name
      // Remove HPL
      .replace(/HPL-/g, "")
      // Convert double hyphens to dash
      .replace(/--/g, "–")
      // Convert single hyphens to dash
      .replace(/-/g, "–")
      // Remove spaces around dashes
      .replace(/\s*–\s*/g, "–")
  );
}
